import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { SettingsUpdateRequest } from "./SettingsUpdateRequest";

@Injectable()
export class DataService_HallSweepSettings {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	SettingsSelect() {
		var postResult$ = new Subject();
		var url = "HallSweep/SettingsSelect?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SettingsUpdate(parms: SettingsUpdateRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/SettingsUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
